import { useContext, useEffect, useState } from "react";
import AuctionHeaderForm from "../../components/AuctionHeaderForm";
import { FoundedAuctionContext } from "../../context/foundedAuctionsContext";
import AuctionsByRegionAndZip from "../../dashboard/AuctionsTypes";
import { useLocation } from "react-router-dom";
import { SearchAuctionsService } from "../../services/auctions.service";
import { StatusCodes } from "http-status-codes";
import TableLoader from "../../components/TableLoader";
import { SeachedAuctionParamsContext } from "../../context/searchedAuctionsParams";
const SearchedAuctions = () => {
  const { foundedAuctions, setFoundedAuctions } = useContext(
    FoundedAuctionContext
  );
  const { searchedAuctionsValues } = useContext(SeachedAuctionParamsContext);
  const [loading, setLoading] = useState<boolean>(false);
  const location = useLocation();
  const { region, radius, category, zip } = location?.state?.params;
  const AuctionFoundByRegion = async () => {
    setLoading(true);
    const response = await SearchAuctionsService({
      region: region!,
    });
    if (response.status && response.status_code === StatusCodes.OK) {
      setFoundedAuctions(response.data.auctions);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (region!) AuctionFoundByRegion();
  }, []);
  return (
    <div className="flex-col justify-center items-center">
      <AuctionHeaderForm
        selectedRegion={region!}
        params={searchedAuctionsValues}
      />
      {loading ? (
        <TableLoader />
      ) : foundedAuctions?.length > 0 ? (
        <div className="mt-5">
          <h1 className="text-bold text-xl p-2">
            {`Featured Auctions in ${
              category
                ? `${foundedAuctions?.[0]?.category_name}`
                : searchedAuctionsValues.region!
                ? `${searchedAuctionsValues.region!}`
                : `${searchedAuctionsValues?.radius} Miles from
          ${searchedAuctionsValues.zip} Zip`
            }  `}
          </h1>
          {!loading &&
            foundedAuctions.map((auction, key) => (
              <AuctionsByRegionAndZip key={key} foundedAuctions={auction} />
            ))}
        </div>
      ) : (
        <div className="text-center">No Auctions found</div>
      )}
    </div>
  );
};
export default SearchedAuctions;
